import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getActionsByLocation } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to access actions.
 * @param {object} options - Options object
 * @param {boolean} [options.active] - Optional filter for active status
 * @param {string} [options.location] - Optional location filter
 */
export const useActions = (options = {}) => {
  const { active } = options;
  const { apiReady } = useApiReady();
  const { selectedLocation } = useAppContext();

  const optionalArgs = typeof active === 'boolean' ? { active } : undefined;

  const effectiveLocation = options.location || selectedLocation;

  return useQuery({
    queryKey: [QUERY_KEYS.ACTION_DATA, effectiveLocation, optionalArgs],
    queryFn: () => getActionsByLocation(effectiveLocation, optionalArgs),
    enabled: Boolean(apiReady && effectiveLocation),
  });
};
